// src/features/bookings/components/BookingList/BookingCard.jsx

import React from 'react';

import { Link } from 'react-router-dom';

import styles from './BookingCard.module.css';

import { formatNumber, BOOKING_TYPE_LABELS, BOOKING_STATUS_LABELS, formatDateTime } from '../../../../shared/utils/formatters';

import Button from '../../../../shared/components/ui/Button';



const STATUS_STYLE = {

  pending:     styles.pending,

  confirmed:   styles.confirmed,

  in_progress: styles.inProgress,

  completed:   styles.completed,

  cancelled:   styles.cancelled,

};



const NEXT_ACTION = {

  pending:     { text: 'تأكيد الحجز', nextStatus: 'confirmed',   variant: 'info'    },

  confirmed:   { text: 'بدء التنفيذ', nextStatus: 'in_progress', variant: 'warning' },

  in_progress: { text: 'إكمال الحجز', nextStatus: 'completed',   variant: 'primary' },

};



const BookingCard = ({ booking, onStatusUpdate, sequenceNumber }) => {

  const remaining  = parseFloat(booking.remaining_amount ?? 0);

  const clientName = booking.client?.name ?? 'عميل غير محدد';

  const nextAction = NEXT_ACTION[booking.status] ?? null;



  return (

    <div className={styles.card}>

      {/* رقم التسلسل */}

      <div className={styles.seqNumber} aria-hidden="true">

        {sequenceNumber}

      </div>



      {/* الهيدر */}

      <div className={styles.header}>

        <h3 className={styles.clientName}>{clientName}</h3>

        <span className={`${styles.status} ${STATUS_STYLE[booking.status] ?? styles.pending}`}>

          {BOOKING_STATUS_LABELS[booking.status] ?? booking.status}

        </span>

      </div>



      {/* نوع الحجز */}

      <p className={styles.bookingType}>

        {BOOKING_TYPE_LABELS[booking.booking_type] ?? booking.booking_type}

      </p>



      {/* تاريخ الحجز */}

      <div className={styles.infoRow}>

        <strong>تاريخ الحجز</strong>

        <span>{booking.booking_date}</span>

      </div>



      {/* تاريخ الإنشاء */}

      {booking.created_at && (

        <div className={styles.infoRow}>

          <strong>تاريخ الإنشاء</strong>

          <span style={{ fontSize: '0.8rem', color: 'var(--text-muted, #94a3b8)' }}>

            {formatDateTime(booking.created_at)}

          </span>

        </div>

      )}



      {/* الملخص المالي */}

      <div className={styles.financialGrid}>

        <div className={styles.financialItem}>

          <span>الإجمالي</span>

          <strong>{formatNumber(booking.total_price)}</strong>

        </div>

        <div className={styles.financialItem}>

          <span>المدفوع</span>

          <strong className={styles.paid}>{formatNumber(booking.total_paid)}</strong>

        </div>

        <div className={styles.financialItem}>

          <span>{remaining < 0 ? 'دفع زيادة' : remaining === 0 ? 'مكتمل' : 'المتبقي'}</span>

          <strong
            className={remaining > 0 ? styles.remaining : ''}
            style={remaining < 0 ? { color: '#10b981', fontWeight: 700 } : {}}
          >

            {remaining < 0
              ? ('+ ' + formatNumber(Math.abs(remaining)))
              : formatNumber(booking.remaining_amount)
            }

          </strong>

        </div>

      </div>



      {/* الأزرار */}

      <div className={styles.actions}>

        <Link to={`/booking/${booking.id}`} className={styles.detailsLink}>

          عرض التفاصيل

        </Link>

        {nextAction && (

          <Button

            variant={nextAction.variant}

            size="sm"

            type="button"

            onClick={() => onStatusUpdate(booking.id, nextAction.nextStatus)}

          >

            {nextAction.text}

          </Button>

        )}

      </div>

    </div>

  );

};



export default BookingCard;